import { useFrame, useThree } from '@react-three/fiber';
import { useRef } from 'react';
import { ECS } from '../state';
import { urls } from '@/config/assets';
import { beerConfig } from '@/config/games/beer';
import { OrthographicCamera, PerspectiveCamera } from '@react-three/drei';
import { degToRad } from 'three/src/math/MathUtils';

export const BeerCamera = () => {
  const { width, height } = useThree((state) => state.viewport);

  const refCamera = useRef();

  // useFrame(() => {
  //   console.log(refCamera.current.position);
  // });

  return (
    <ECS.Entity>
      <ECS.Component
        name="isCamera"
        data={true}
      />
      <ECS.Component
        name="position"
        data={{ x: 0, y: 0, z: 0 }}
      />
      <ECS.Component name="followPlayer" />
      <ECS.Component
        name="followOffset"
        data={{
          x: beerConfig.camera.offset.x,
          y: beerConfig.camera.offset.y,
          z: beerConfig.camera.offset.z,
        }}
      />
      <ECS.Component name="three">
        <PerspectiveCamera
          ref={refCamera}
          position={[0, beerConfig.camera.offset.y, beerConfig.camera.offset.z]}
          makeDefault
          fov={45}
          rotation-x={degToRad(0)}
          // far={100}
        />
        {/* <OrthographicCamera
          position={[0, 0, 10]}
          args={[width / -2, width / 2, height / -2, height / 2, 0.1, 100]}
          makeDefault
        /> */}
      </ECS.Component>
    </ECS.Entity>
  );
};
